import React from 'react';

import { Box, SxProps, Typography, Theme } from '@mui/material';

import { SheetStatus } from '../../../common/types/SaveSheet';

type Props = {
  status: SheetStatus | 'Search';
  sx?: SxProps<Theme>;
};

const StatusLabel: React.FC<Props> = ({ sx, status }) => {
  const getStatusColor = (status: SheetStatus | 'Search') => {
    let color: string;
    switch (status) {
      case SheetStatus.APPROVED:
        color = 'rgba(82, 86, 98, 0.1)';
        break;
      case SheetStatus.BILLED:
        color = 'rgba(34, 123, 239, 0.1)';
        break;
      case SheetStatus.DRAFT:
        color = 'rgba(241, 157, 96, 0.1)';
        break;
      case SheetStatus.FINALIZED:
        color = 'rgba(111, 207, 151, 0.2)';
        break;
      case SheetStatus.REJECTED:
        color = '#eb575733';
        break;
      case SheetStatus.PROCESSED:
        color = '#26BBFF4D';
        break;
      case SheetStatus.UPLOADED:
        color = 'rgba(82, 86, 98, 0.2)';
        break;
      default:
        color = 'rgba(34, 123, 239, 0.3)';
        break;
    }
    return color;
  };

  // const getTextColor = (status: SheetStatus) => {
  //   let color: string;
  //   switch (status) {
  //     case SheetStatus.APPROVED:
  //       color = "rgba(82, 86, 98, 0.6)";
  //       break;
  //     case SheetStatus.BILLED:
  //       color = "#227BEF";
  //       break;
  //     case SheetStatus.DRAFT:
  //       color = "#F19D60";
  //       break;
  //     case SheetStatus.FINALIZED:
  //       color = "#20C21D";
  //       break;
  //     case SheetStatus.REJECTED:
  //       color = "#ffffff";
  //       break;
  //   }
  //   return color;
  // };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '24px',
        py: '2px',
        px: '10px',
        borderRadius: '40px',
        backgroundColor: getStatusColor(status),
        ...sx,
      }}
    >
      <Typography sx={{ fontSize: '13px' }}>{status}</Typography>
    </Box>
  );
};

export default StatusLabel;
